module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-textarea"
  }, [_c('label', {
    staticClass: "p-input-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "p-input-wrapper"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    staticClass: "p-textarea",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.innerModel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerModel = $event.target.value
      }, _vm.onChange]
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f51bb25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/textarea.vue
// module id = 31
// module chunks = 0